module.exports = __webpack_public_path__ + "static/img/IMG_7240.7d9507b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/items/nyomtatott-konyhahatfal/mickey/IMG_7240.jpg
// module id = 584
// module chunks = 0